import { Directive } from '@angular/core';
import { BrnSelectGroup } from '@spartan-ng/brain/select';

@Directive({
	selector: '[hlmSelectGroup], hlm-select-group',
	hostDirectives: [BrnSelectGroup],
})
export class HlmSelectGroup {}
